import * as React from "react";

import { User } from './userType';
import { defaultUser } from "./userDefault";

const UserContext = React.createContext({
  user: defaultUser,
  setUser: (user: User) => { }
});

export { UserContext };